import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

export default function ConsoleToast({
    show,
    message,
    tone = 'success',
    duration = 2600,
    onClose,
    closeLabel = 'Close',
}) {
    const onCloseRef = useRef(onClose)

    useEffect(() => {
        onCloseRef.current = onClose
    }, [onClose])

    useEffect(() => {
        if (!show) return undefined
        const timer = window.setTimeout(() => onCloseRef.current?.(), duration)
        return () => window.clearTimeout(timer)
    }, [duration, show])

    if (!show || !message || typeof document === 'undefined') return null

    return createPortal(
        <div className={`console-toast is-${tone}`} role="status" aria-live="polite">
            <span className="console-toast__icon"><i className={`fa ${tone === 'success' ? 'fa-check' : 'fa-exclamation-triangle'}`} /></span>
            <strong>{message}</strong>
            <button type="button" onClick={onClose} aria-label={closeLabel} title={closeLabel}><i className="fa fa-times" /></button>
        </div>,
        document.body
    )
}
